import { render, staticRenderFns } from "./Tutorials.vue?vue&type=template&id=64f7fa1a&"
import script from "./Tutorials.vue?vue&type=script&lang=js&"
export * from "./Tutorials.vue?vue&type=script&lang=js&"
import style0 from "./Tutorials.vue?vue&type=style&index=0&id=64f7fa1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports